<template>
  <div>
    <h2>{{titulo}}</h2>
    <b-row>
      <FormGroup
        cols="4"
        label="Sucursal">
        <v-select 
          @input="onChangeFecha"
          v-model="filtro.id_sucursal" 
          :clearable=false
          label="desc_sucursal"
          :options="this.$store.getters['usuario/getSucursalesFiltro']({id_sucursal:$store.state.usuario.sucursales.map((element) => element.id_sucursal).join(),desc_sucursal:'Todo'})" 
          :reduce="option=>option.id_sucursal">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha inicio"> 
        <Datepicker @input="onChangeFecha" input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_i"></Datepicker>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha término"> 
        <Datepicker @input="onChangeFecha" input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_t"></Datepicker>
      </FormGroup>
    </b-row>
    <DataTable
      :loading="loading"
      :columns="columns"
      :rows="rows"
      :paging=false
      :buttons=false
      :searching="false"
      clases="table-bordered nowrap">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'kpi'">
          {{ Math.round(props.row.kpi*100)/100 }} 
        </span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { widgetClienteService } from '@/services';
import { utils } from '@/helpers';

export default {
  props:['titulo'],
  data(){
    return {
      loading: true,
      filtro: {
        id_sucursal:this.$store.state.usuario.sucursales.map((element) => element.id_sucursal).join(),
        fecha_i: new Date(new Date().getFullYear(), new Date().getMonth(),1),
        fecha_t: new Date()
      },
      columns:[
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Kpi', field: 'kpi'},
        ],
      rows:[],
    }
  },
  watch:{
    '$store.state.usuario.sucursales': function(){
      this.filtro.id_sucursal = this.$store.state.usuario.sucursales.map((element) => element.id_sucursal).join();
    },
  },
  mounted(){
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      widgetClienteService.getWidgetClienteRvcIpaKpi({
        id_sucursal: this.filtro.id_sucursal.split(","),
        fecha_i:utils.DateToFecha(this.filtro.fecha_i, 'dd-mm-yyyy'),
        fecha_t:utils.DateToFecha(this.filtro.fecha_t, 'dd-mm-yyyy')
      }).then(data => {
        this.rows = data.data;

        this.loading = false;
      });
    },
    onChangeFecha(){
      this.cargarDatos();
    },
  }
}
</script>

<style scoped>
</style>
